import React from 'react';
const Erro404 = () => {
    return (
        <div className="jumbotron">
            <h1 className="display-3">erro 404</h1>
        </div>
    );
}
export default Erro404;



// WEBPACK FOOTER //
// ./src/classes/errors/Erro404.js